<template>
    <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg">
        <g fill="#9A1F35" fill-rule="nonzero">
            <path d="M19.971.9H7.59C3.559.9.279 4.179.279 8.209v12.383c0 4.03 3.28 7.308 7.31 7.308H19.97c4.03 0 7.309-3.279 7.309-7.308V8.209C27.28 4.179 24 .9 19.97.9zm5.726 19.692a5.732 5.732 0 0 1-5.726 5.725H7.59a5.732 5.732 0 0 1-5.726-5.725V8.209a5.732 5.732 0 0 1 5.726-5.726H19.97a5.732 5.732 0 0 1 5.726 5.726v12.383z"/>
            <path d="M13.78 7.017c-4.07 0-7.383 3.312-7.383 7.383 0 4.07 3.312 7.383 7.383 7.383 4.07 0 7.383-3.312 7.383-7.383 0-4.07-3.312-7.383-7.383-7.383zm0 13.183a5.806 5.806 0 0 1-5.8-5.8c0-3.198 2.602-5.8 5.8-5.8s5.8 2.602 5.8 5.8-2.602 5.8-5.8 5.8zM21.34 4.396a2.184 2.184 0 0 0-2.182 2.181c0 1.203.978 2.182 2.181 2.182a2.184 2.184 0 0 0 2.182-2.182 2.184 2.184 0 0 0-2.182-2.181zm0 2.78a.6.6 0 1 1 0-1.2.6.6 0 0 1 0 1.2z"/>
        </g>
    </svg>
</template>

<script>
export default {

}
</script>
